import React from 'react';

class PageContainer extends React.Component {

	render() {
		const slug = this.props.match.params.slug;

		return (

			<div>
				{ slug === 'about' &&
				<section className="block2a">
					<div className="container" style={{paddingTop: 30, paddingBottom: 30}}>
						<div className="row">
							<div className="col-md-8 mt-4 mb-4">
								<h1 className="mt-4">About the Mental Health Passport</h1>

								<h2 style={{marginTop: `1em`}}>Who we are</h2>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									We are Chilypep’s STAMP group (Support, Think, Act, Motivate, Participate), a group of empowered
									and motivated young people, aged 14-25, who have experience of and/or are passionate about
									mental health issues. We work to improve the mental health and emotional wellbeing of young
									people across the city of Sheffield by campaigning to STAMP out stigma, working with local
									services to improve them, and getting young people’s voices heard on the issues that affect them!
								</p>
								<p style={{fontSize: `1.2em`}}>
									The mental health passport was made by us... by young people, for young people! 
								</p>

								<h2 style={{marginTop: `1em`}}>What this is</h2>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									This passport is a way for you to say what you want, in your own words about your mental health. It can only be seen by you unless you decide to share it with someone else. You can fill it in on a computer or smart phone. It can be downloaded (as a PDF) and shown either on your phone, printed, or sent via e-mail. You can write as little or as much as you want because this passport is yours! 
								</p>
								<p style={{fontSize: `1.2em`}}>
									We thought it would be good to have a calendar to help remember how things have been, or when things happen. Along with the passport we made an emoji journal. You can choose any emoji to match your day to remind you of how you were feeling or what you were doing. 
								</p>
								<p style={{fontSize: `1.2em`}}>
									There is a section where you can find help and advice recommended by the young people of the STAMP group.
								</p>

								<h2 style={{marginTop: `1em`}}>Why</h2>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									My Mental Health Passport has been developed to give young people some control over their own information. STAMP group and other young people we spoke to said they don’t like having to repeat themselves, especially if it’s something that is difficult to talk about. My Mental Health Passport can be used on your first appointment (or any appointment) to help you find the right words to say in a way that you feel comfortable. We also found that it was confusing not knowing what other people know about us, so this was a way to be in control of our information.
								</p>
								<p style={{fontSize: `1.2em`}}>
									We hope that reflecting on how you feel and seeing it written down is a good thing for your wellbeing. This project also proves that young people can make a difference and we hope it inspires you to get involved in making health services better for young people!
								</p>

							</div>
							<div className="col-md-4" style={{ paddingTop: 30, paddingRight: 60, paddingBottom: 60, paddingLeft: 60 }}>
								<img src="/assets/img/icon-passport.svg" className="img-responsive" style={{ maxHeight: 200, marginTop: `2em` }} alt="Passport"/>
							</div>

						</div>
					</div>
				</section>
				}
				{ slug === 'privacy' &&
				<section className="block2a">
					<div className="container" style={{paddingTop: 30, paddingBottom: 30}}>
						<div className="row">
							<div className="col-md-8 mt-4 mb-4 offset-md-2">
								<h2 className="mt-4">Privacy Policy – Look after your data - It has value!</h2>

								<p className="mt-3">
									<strong>This is a confidential website and is password protected. It’s for you to share with who you want.</strong>
								</p>
								<p className="mt-3">
									Ways to keep your information safe:
								</p>
								<p className="mt-3">
								<ul>
									<li>Log out of the mental health passport when you’ve finished using it. </li>
									<li>If you download it, delete the file from the downloads folder.</li>
									<li>If you print it, don’t forget to pick it up from the printer.</li>
									<li>If you email it, check you have the right email address.</li>
								</ul>
								</p>
								<p className="mt-3">
									We work to give you the best and most secure service. The only information that is stored is what you put in passport and emoji calendar, this is stored in a secure database within the EU. IP addresses of computers using the website may be stored within log files. No analytics software is used on the website.
								</p>
								<p className="mt-3">
									Chilypep doesn’t have access to the personal information that you have saved on your mental health passport. In our organisation we make sure we consider and balance any potential impact on you (both positive and negative) and your rights before we process any personal data for our legitimate interests. We do not use your personal data for activities where our interests are overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law). You can know more about how we assess our legitimate interests against any potential impact on you in respect of specific activities by looking at our <a href="https://www.chilypep.org.uk/" className="font-weight-bold" target="_blank" rel="nofollow">privacy policy on our website</a> or <a href="mailto:info@chilypep.org.uk" className="font-weight-bold">contacting us</a>.
								</p>
								<p className="mt-3">
									Cookies: It is necessary for us to store a small amount of information, usually through cookies, to maintain your session if you create and login to a MyMHP account. No first party cookies are used within the site.
								</p>

							</div>

						</div>
					</div>
				</section>
				}

			</div>
		);
	}
}




export default PageContainer;




// WEBPACK FOOTER //
// ./src/js/components/containers/PageContainer.js